import request from '@/router/axios';
const PROGRESS_API = '/api/produce/transport-plan-progress';

function unwrap(res) {
    const body = res && res.data
    if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
    return body
}

export const add = (row) => {
    return request({
        url: '/api/produce/transport-contract/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/transport-contract/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/transport-contract/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/transport-contract/select/page',
        method: 'get',
        params: {
            ...params
        }
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/transport-contract/export',
        method: 'get',
        params: {
            ...params
        },
        responseType: 'blob'
    })
}
export const fetchProgressOverview = (data) => {
    return request({
        url: `${PROGRESS_API}/overview`,
        method: 'post',
        data
    }).then(unwrap)
}
export const fetchCustomerRank = (data) => {
    return request({
        url: `${PROGRESS_API}/customer-rank`,
        method: 'post',
        data
    }).then(unwrap)
}
export const fetchContractCargoBreakdown = (data) => {
    return request({
        url: `${PROGRESS_API}/contract-cargo-breakdown`,
        method: 'post',
        data
    }).then(unwrap)
}
export const fetchContractTimeTrend = (data) => {
    return request({
        url: `${PROGRESS_API}/contract-time-trend`,
        method: 'post',
        data
    }).then(unwrap)
}
export const fetchUrgeSuggestionPage = (data) => {
    return request({
        url: `${PROGRESS_API}/urge-suggestion-page`,
        method: 'post',
        data
    }).then(unwrap)
}
export const exportUrgeSuggestion = (data) => {
    return request({
        url: `${PROGRESS_API}/urge-suggestion-export`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}
export const fetchRailwayFeePerformancePage = (data) => {
    return request({
        url: `${PROGRESS_API}/railway-fee-performance-page`,
        method: 'post',
        data
    }).then(unwrap)
}
export const exportRailwayContractPdf = (data) => {
    return request({
        url: `${PROGRESS_API}/railway-contract-export-pdf`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}
export const remove = (id) => {
    return request({
        url: '/api/produce/transport-contract/delete/id',
        method: 'get',
        params: {
            id
        }
    })
}
// 通用上传（复用已有OSS附件上传接口）
export const uploadEndpoint = "/api/blade-resource/oss/endpoint/put-file-attach";
